import { useEffect, useRef } from "react";
import { usePostHog } from "./context";
import { useRouterState } from "@tanstack/react-router";

export default function PostHogPageView() {
  const posthog = usePostHog();
  const routerHref = useRouterState({ select: (state) => state.location.href });
  const lastCapturedUrlRef = useRef<string | null>(null);

  // Capture when the client becomes available so the first route is not missed.
  useEffect(() => {
    if (!posthog || !routerHref) {
      return;
    }

    const currentUrl = new URL(routerHref, window.location.origin).toString();
    if (lastCapturedUrlRef.current === currentUrl) {
      return;
    }

    lastCapturedUrlRef.current = currentUrl;
    posthog.capture("$pageview", {
      $current_url: currentUrl,
    });
  }, [posthog, routerHref]);

  return null;
}
